import { Pagination, Tax } from '~core/models/core.models';

export const TAX_MOCK_LIST: Pagination<Tax> = {
  page: 1,
  itemPerPage: 10,
  filters: [],
  orderBy: {
    createdAt: 'desc'
  },
  itemOffset: 0,
  fullyItems: 5,
  pageNumber: 1,
  items: [
    // {
    //   id: faker.string.uuid(),
    //   name: 'Taxe sur la valeur ajoutée',
    //   type: 'TVA',
    //   rate: 0.18,
    //   price: {
    //     amount: 100,
    //     currency: 'USD'
    //   },
    //   description: 'description taxe'
    // },
    // {
    //   id: faker.string.uuid(),
    //   name: 'Taxe réduite sur la valeur ajoutée',
    //   type: 'TVA',
    //   rate: 0.09,
    //   price: {
    //     amount: 200,
    //     currency: 'USD'
    //   },
    //   description: 'description taxe'
    // },
    // {
    //   id: faker.string.uuid(),
    //   name: 'TVA intermédiaire',
    //   type: 'TVA',
    //   rate: 0.12,
    //   price: {
    //     amount: 150,
    //     currency: 'USD'
    //   },
    //   description: 'description taxe'
    // },
    // {
    //   id: faker.string.uuid(),
    //   name: 'TVA spéciale',
    //   type: 'TVA',
    //   rate: 0.2,
    //   price: {
    //     amount: 250,
    //     currency: 'USD'
    //   },
    //   description: 'description taxe'
    // },
    // {
    //   id: faker.string.uuid(),
    //   name: 'TVA exceptionnelle',
    //   type: 'TVA',
    //   rate: 0.25,
    //   price: {
    //     amount: 300,
    //     currency: 'USD'
    //   },
    //   description: 'description taxe'
    // }
  ]
};
